// extracted by mini-css-extract-plugin
export default {"tableTransparent":"index_tableTransparent__2X+6g","collapseSecondary":"index_collapseSecondary__sxFE6"};